import { z } from 'zod';
import { ACCOUNT_TYPE_VALUES } from '../../molecules/AccountTypeToggleGroup/AccountTypeToggleGroup.types';
import { VISIBILITY_VALUES } from '../../molecules/VisibilityToggleGroup/VisibilityToggleGroup.types';

export const favoriteListModalFormSchema = z.object({
  listName: z.string().trim().min(1, { message: 'List name is required' }),
  visibility: z.enum(VISIBILITY_VALUES),
  accountType: z.enum(ACCOUNT_TYPE_VALUES).optional(),
});
